import { API_ENDPOINTS, createApiUrl, ServiceType } from 'src/contstant/apiEndpoints';
import { apiClient } from '../apiClient';
import { apiHeliosClient } from '../apiHeliosClient';
import {
  DeleteMediaRequest,
  GetMediaRequest,
  GetMediaResponse,
  ListMediaByIdsRequest,
  ListMediaRequest,
  ListMediaResponse,
} from 'src/types/helios/Media';
import {
  UploadMediaCommand,
  UploadMediaCommandInput,
} from '@amzn/gbsa-helios-typescript-client';

export const base64ToUint8Array = (base64String: string): Uint8Array => {
  const base64WithoutPrefix = base64String.replace(/^data:[^;]+;base64,/, '');

  // Convert base64 string to byte array
  let byteString: string;
  try {
    byteString = window.atob(base64WithoutPrefix);
  } catch (error) {
    throw new Error('Invalid base64 string');
  }
  const uint8Array = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i++) {
    uint8Array[i] = byteString.charCodeAt(i);
  }

  return uint8Array;
};

export const mediaService = {
  // Upload media
  upload: (data: Omit<UploadMediaCommandInput, 'file'> & { file: string }) => {
    return apiHeliosClient.send(
      new UploadMediaCommand({
        ...data,
        file: base64ToUint8Array(data.file),
      }),
    );
  },

  // Get media by ID
  getById: (data: GetMediaRequest) => {
    return apiClient.get<GetMediaResponse>(
      ServiceType.HELIOS,
      createApiUrl(API_ENDPOINTS.HELIOS_SERVICE.MEDIA.GET(data.programId, data.mediaId)),
    );
  },

  // Delete media
  delete: (data: DeleteMediaRequest) => {
    const queryParams = {
      deletedBy: data.deletedBy,
    };

    return apiClient.delete(
      ServiceType.HELIOS,
      createApiUrl(
        API_ENDPOINTS.HELIOS_SERVICE.MEDIA.DELETE(data.programId, data.mediaId),
      ),
      queryParams,
    );
  },

  // List media
  list: (data: ListMediaRequest) => {
    const { programId, ...queryParams } = data;
    return apiClient.get<ListMediaResponse>(
      ServiceType.HELIOS,
      createApiUrl(API_ENDPOINTS.HELIOS_SERVICE.MEDIA.LIST(programId)),
      queryParams,
    );
  },

  listByIds: (data: ListMediaByIdsRequest) => {
    const { programId, mediaIds, ...otherParams } = data;
    const params = new URLSearchParams();
    mediaIds.forEach((id) => params.append('mediaIds', id));
    Object.entries(otherParams).forEach(([key, value]) => {
      if (value !== undefined) params.append(key, String(value));
    });
    const url = `${createApiUrl(API_ENDPOINTS.HELIOS_SERVICE.MEDIA.LIST_BY_IDS(programId))}?${params.toString()}`;
    return apiClient.get<ListMediaResponse>(ServiceType.HELIOS, url);
  },
};
